var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-overlay",
        {
          attrs: { absolute: "" },
          model: {
            value: _vm.stockDefaultDetailPosting,
            callback: function($$v) {
              _vm.stockDefaultDetailPosting = $$v
            },
            expression: "stockDefaultDetailPosting"
          }
        },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "30" }
          })
        ],
        1
      ),
      _c("v-text-field", {
        attrs: {
          label: "Price",
          type: "number",
          prefix: "₱",
          "error-messages": _vm.stockDefaultDetailPostErrors.price
        },
        model: {
          value: _vm.price,
          callback: function($$v) {
            _vm.price = _vm._n($$v)
          },
          expression: "price"
        }
      }),
      _c(
        "v-btn",
        {
          attrs: {
            color: _vm.editMode ? "yellow darken-4" : "primary",
            small: "",
            dark: ""
          },
          on: { click: _vm.sendRequest }
        },
        [_c("span", [_vm._v(_vm._s(_vm.editMode ? "Update" : "Save"))])]
      ),
      _vm.editMode
        ? _c(
            "v-btn",
            {
              staticClass: "ml-2",
              attrs: { color: "error", small: "", dark: "" },
              on: { click: _vm.deleteItem }
            },
            [_c("span", [_vm._v("delete")])]
          )
        : _vm._e(),
      _vm.editMode
        ? _c(
            "v-btn",
            {
              staticClass: "ml-2",
              attrs: { color: "primary", small: "", dark: "" },
              on: { click: _vm.resetDialog }
            },
            [_c("span", [_vm._v("cancel")])]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }